<div class="editor-layout" [class.sidebar-collapsed]="editorState?.sidebar?.isCollapsed">

  <!-- TOP MENU -->
  <app-top-menu class="top-menu"></app-top-menu>

  <div class="main-container">

    <!-- SIDEBAR ICONS -->
    <div class="sidebar-icons">
      <button mat-icon-button class="sidebar-icon" [class.active]="editorState?.sidebar?.activePanel === 'explorador'"
        (click)="onPanelSelect('explorador')" matTooltip="Explorador de Escritos" matTooltipPosition="right">
        <mat-icon>folder</mat-icon>
      </button>

      <button mat-icon-button class="sidebar-icon" [class.active]="editorState?.sidebar?.activePanel === 'variables'"
        (click)="onPanelSelect('variables')" matTooltip="Variables Disponibles" matTooltipPosition="right">
        <mat-icon>code</mat-icon>
      </button>

      <button mat-icon-button class="sidebar-icon" [class.active]="editorState?.sidebar?.activePanel === 'plantillas'"
        (click)="onPanelSelect('plantillas')" matTooltip="Plantillas de Escritos" matTooltipPosition="right">
        <mat-icon>description</mat-icon>
      </button>

      <button mat-icon-button class="sidebar-icon" [class.active]="editorState?.sidebar?.activePanel === 'versiones'"
        (click)="onPanelSelect('versiones')" matTooltip="Versiones del Escrito Actual" matTooltipPosition="right">
        <mat-icon>history</mat-icon>
      </button>

      <div class="sidebar-spacer"></div>

      <button mat-icon-button class="sidebar-icon" (click)="onSidebarToggle()"
        [matTooltip]="editorState?.sidebar?.isCollapsed ? 'Expandir Panel' : 'Colapsar Panel'"
        matTooltipPosition="right">
        <mat-icon>
          {{editorState?.sidebar?.isCollapsed ? 'chevron_right' : 'chevron_left'}}
        </mat-icon>
      </button>
    </div>

    <!-- SIDEBAR CONTENT -->
    <div class="sidebar-content" [style.width.px]="sidebarWidth"
      *ngIf="!editorState?.sidebar?.isCollapsed && editorState?.sidebar?.activePanel">



      <app-explorador-panel *ngIf="editorState?.sidebar?.activePanel === 'explorador'">
      </app-explorador-panel>

      <app-variables-panel *ngIf="editorState?.sidebar?.activePanel === 'variables'">
      </app-variables-panel>

      <app-plantillas-panel *ngIf="editorState?.sidebar?.activePanel === 'plantillas'">
      </app-plantillas-panel>

      <app-versiones-panel *ngIf="editorState?.sidebar?.activePanel === 'versiones'">
      </app-versiones-panel>
    </div>

    <!-- SPLITTER -->
    <div class="splitter" (mousedown)="onSplitterMouseDown($event)" *ngIf="!editorState?.sidebar?.isCollapsed">
    </div>

    <!-- EDITOR AREA -->
    <div class="editor-area">

      <!-- TABS -->
      <app-editor-tabs></app-editor-tabs>

      <!-- EDITOR CONTENT -->
      <div class="editor-content">
        <app-tinymce-editor *ngIf="editorState?.activeTabId" [tabId]="editorState.activeTabId">
        </app-tinymce-editor>

        <!-- WELCOME SCREEN -->
        <div *ngIf="!editorState?.activeTabId" class="welcome-screen">
          <div class="welcome-content">
            <mat-icon class="welcome-icon">edit_note</mat-icon>
            <h2>Editor de Escritos</h2>
            <p>Selecciona un escrito del explorador o crea uno nuevo para comenzar</p>

            <div class="welcome-actions">
              <button mat-raised-button color="primary" (click)="onNewEscrito()">
                <mat-icon>add</mat-icon>
                Nuevo Escrito
              </button>
              <button mat-stroked-button (click)="onPanelSelect('explorador')">
                <mat-icon>folder_open</mat-icon>
                Explorar Escritos
              </button>
              <button mat-stroked-button (click)="onPanelSelect('plantillas')">
                <mat-icon>description</mat-icon>
                Ver Plantillas
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
